export class Ip2Ir {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.irMode = 'IR';
        this.asyncHandlers = [
            {
                name: 'anyIrCommand',
                regExp: /sendir,(\d+):(\d+),(\d+),.+/i,
                callback: (match) => {
                    this.socket.send(`completeir,${match[1]}:${match[2]},${match[3]}`);
                },
            },
            {
                name: 'devices',
                regExp: /getdevices/i,
                callback: (match) => {
                    this.socket.send(`device,0,0 ETHERNET\rdevice,1,3 IR\rendlistdevices`);
                },
            },
            {
                name: 'ping',
                regExp: /ping/i,
                callback: (match) => {
                    this.socket.send(`ERR_0:0,001`);
                },
            },
            {
                name: 'setIr',
                regExp: /set_IR,(\d+):(\d+),(.+)/i,
                callback: (match) => {
                    if (match[3])
                        this.irMode = match[3];
                    this.socket.send(`IR,${match[1]}:${match[2]},${match[3]}`);
                },
            },
            {
                name: 'getIr',
                regExp: /get_IR,(\d+):(\d+)/i,
                callback: (match) => {
                    this.socket.send(`IR,${match[1]}:${match[2]},${this.irMode}`);
                },
            },
            {
                name: 'stopIr',
                regExp: /stopir,(\d+):(\d+)/i,
                callback: (match) => {
                    this.socket.send(`stopir,${match[1]}:${match[2]}`);
                },
            },
            {
                name: 'versionIr',
                regExp: /getversion/i,
                callback: (match) => {
                    this.socket.send(`710-1005-056}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.log.debug(`invalid, match = ${JSON.stringify(match, null, 4)}`);
                },
            },
        ];
    }
}
Ip2Ir.emulatorType = 'socketEmulator';
Ip2Ir.key = '-MSeHd3FH9_LOy7AM0Ed';
